<template>

    <div>
        <section class="top-cat">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 v-if="lang === 'ar'">تسجل الدخول</h1>
                        <h1 v-else>ACCOUNT LOGIN PAGE</h1>
                        <p v-if="lang === 'ar'"><span>نقاط الولاء</span></p>
                        <p v-else>MANAGE YOUR POINTS</p>
                    </div>


                    <div v-bind:class="{ 'rtl': rtl}" id="signup" class="container-fluid">
                        <div class="row">
                            <div class="container" v-if="view === 'login'">
                                <div class="row">
                                    <div class="col activeTab">
                                        <h5 v-if="lang === 'ar'"><icon name="lock" scale="2"></icon> &nbsp; أدخل تفاصيل تسجيل الدخول الخاصة بك</h5>
                                        <h5 v-else><icon name="lock" scale="2"></icon> &nbsp; Enter your login details</h5>
                                    </div>
                                </div>
                                <div class="row shadows">
                                    <div class="col" style="background-color: white; border: solid 1px darkgrey;">

                                        <div class="signup-form">
                                            <form @submit.prevent="onSubmit"
                                                  @keydown="form.errors.clear($event.target.name)"
                                                  @change="form.errors.clear($event.target.name)"
                                                  @click.right="form.errors.clear($event.target.name)"
                                            >
                                                <div class="input">
                                                    <h5 v-if="lang === 'ar'" for="email">عنوان بريدك الإلكتروني</h5>
                                                    <h5 v-else for="email">Your Email Address</h5>
                                                    <input
                                                            :class="{'is-danger-input': form.errors.has('email')}"
                                                            type="email"
                                                            id="email"
                                                            v-model="form.email">
                                                    <span class="help is-danger" v-if="form.errors.has('email')" v-text="form.errors.get('email')"></span>
                                                </div>
                                                <div class="col-md-12">&nbsp;</div>
                                                <div class="input">
                                                    <h5 v-if="lang === 'ar'" for="password">كلمه المرور</h5>
                                                    <h5 v-else for="password">Password</h5>
                                                    <input
                                                            :class="{'is-danger-input': form.errors.has('password')}"
                                                            type="password"
                                                            id="password"
                                                            v-model="form.password">
                                                    <span class="help is-danger" v-if="form.errors.has('password')" v-text="form.errors.get('password')"></span>
                                                </div>

                                                <b-alert v-if="form.errors.error.title || form.errors.error.message" show variant="warning">
                    <span class="help is-danger">
                        <icon name="warning" scale="0.9"></icon> &nbsp;
                        <strong v-if="form.errors.error.title">{{form.errors.error.title}}: <br/></strong>
                        {{form.errors.error.message}}
                    </span>
                                                </b-alert>

                                                <div>

                                                    <p align="right">
                                                        <span style="color: #1e88e5; cursor: pointer;" v-on:click="forgotPassword">Forgot Password?</span>
                                                        &nbsp; &nbsp; - &nbsp; &nbsp;
                                                        <span style="color: #1e88e5; cursor: pointer;" v-on:click="forgotEmail">Forgot Email Address?</span></p>
                                                    <button v-if="lang === 'ar'" type="submit" class="buttonx"><icon name="lock" scale="1.5"></icon> تسجيل الدخول</button>
                                                    <button v-if="lang === 'en'"  type="submit" class="buttonx"><icon name="lock" scale="1.5"></icon> Log in now</button>&nbsp;
                                                    <h5 v-if="lang === 'ar'" > مستخدمون جدد ، يرجى  <router-link to="/register">الضغط هنا</router-link>   لتسجيل حسابك أو بطاقة وافر </h5>
                                                    <h5 v-else>New users, please <router-link to="/register">Click Here</router-link> to register your account or Waffir Card.</h5>
                                                </div>
                                            </form>
                                        </div>

                                    </div>
                                </div>
                            </div>


                            <div class="container" v-if="view === 'email'">
                                <div class="row">
                                    <div class="col activeTab">
                                        <h5 v-if="lang === 'ar'"><icon name="lock" scale="2"></icon> &nbsp;هل نسيت البريد الإلكتروني؟ الرجاء إدخال رقم هاتفك المحمول</h5>
                                        <h5 v-else><icon name="lock" scale="2"></icon> Forgot Email? Please enter your mobile number</h5>
                                    </div>
                                </div>
                                <div class="row shadows">
                                    <div class="col" style="background-color: white; border: solid 1px darkgrey;">

                                        <div class="signup-form">
                                            <form @submit.prevent="requestEmail"
                                                  @keydown="emailForm.errors.clear($event.target.name)"
                                                  @change="emailForm.errors.clear($event.target.name)"
                                                  @click.right="emailForm.errors.clear($event.target.name)"
                                            >
                                                <div class="input">
                                                    <h5 v-if="lang === 'ar'">رقم الجوال</h5>
                                                    <h5 v-else>Mobile Number:</h5>
                                                    <input
                                                        :class="{'is-danger-input': form.errors.has('mobile')}"
                                                        type="text"
                                                        id="mobile"
                                                        v-model="emailForm.mobile">
                                                    <span class="help is-danger" v-if="emailForm.errors.has('mobile')" v-text="emailForm.errors.get('mobile')"></span>
                                                </div>

                                                <b-alert v-if="emailForm.errors.error.title || emailForm.errors.error.message" show variant="warning">
                                                    <span class="help is-danger">
                                                        <icon name="warning" scale="0.9"></icon> &nbsp;
                                                        <strong v-if="emailForm.errors.error.title">{{emailForm.errors.error.title}}: <br/></strong>
                                                        {{emailForm.errors.error.message}}
                                                    </span>
                                                </b-alert>
                                                <h5 v-if="lang === 'ar'">المستخدمين المسجلين ، يرجى <router-link to="/login">الضغط هنا</router-link> لتسجيل الدخول</h5>
                                                <h5 v-else>Registered users, please <span style="color: #1e88e5; cursor: pointer;" @click="view = 'login'">Click Here</span> to login to your account</h5>

                                                <div>
                                                    <p align="right">
                                                        <span style="color: #1e88e5; cursor: pointer;" v-on:click="forgotPassword">Forgot Password?</span>
                                                    <button v-if="lang === 'ar'" type="submit" class="buttonx"><icon name="envelope" scale="1.5"></icon> طلب البريد الإلكتروني  </button>
                                                    <button v-if="lang === 'en'"  type="submit" class="buttonx"><icon name="envelope" scale="1.5"></icon> Request Email</button>&nbsp;
                                                    </p>
                                                </div>
                                            </form>
                                        </div>

                                    </div>
                                </div>
                            </div>


                            <div class="container" v-if="view === 'password'">
                                <div class="row">
                                    <div class="col activeTab">
                                        <h5 v-if="lang === 'ar'"><icon name="lock" scale="2"></icon> &nbsp;هل نسيت كلمة المرور؟ الرجاء إدخال رقم هاتفك المحمول</h5>
                                        <h5 v-else><icon name="lock" scale="2"></icon> Forgot Password? Please enter your mobile number</h5>
                                    </div>
                                </div>
                                <div class="row shadows">
                                    <div class="col" style="background-color: white; border: solid 1px darkgrey;">

                                        <div class="signup-form">
                                            <form @submit.prevent="requestEmail"
                                                  @keydown="passwordForm.errors.clear($event.target.name)"
                                                  @change="passwordForm.errors.clear($event.target.name)"
                                                  @click.right="passwordForm.errors.clear($event.target.name)"
                                            >
                                                <div class="input" v-show="passwordForm.status === 'code'">
                                                    <h5 v-if="lang === 'ar'">رقم الجوال</h5>
                                                    <h5 v-else>Mobile Number:</h5>
                                                    <input
                                                        :class="{'is-danger-input': passwordForm.errors.has('mobile')}"
                                                        type="text"
                                                        id="mobile"
                                                        v-model="passwordForm.mobile">
                                                    <span class="help is-danger" v-if="passwordForm.errors.has('mobile')" v-text="passwordForm.errors.get('mobile')"></span>
                                                </div>

                                              <div class="input" v-show="passwordForm.status === 'verify'">
                                                <h5 v-if="lang === 'ar'">شيفرة التأكيد</h5>
                                                <h5 v-else>Verification Code:</h5>
                                                <input
                                                    :class="{'is-danger-input': passwordForm.errors.has('code')}"
                                                    type="number"
                                                    minlength="6"
                                                    id="code" required
                                                    v-model="passwordForm.token">
                                                <span class="help is-danger" v-if="passwordForm.errors.has('code')" v-text="passwordForm.errors.get('code')"></span>
                                              </div>

                                              <div class="input" v-show="passwordForm.status === 'verify'">
                                                <h5 v-if="lang === 'ar'">كلمه السر</h5>
                                                <h5 v-else>Password:</h5>
                                                <input
                                                    :class="{'is-danger-input': passwordForm.errors.has('password')}"
                                                    type="password"
                                                    id="password" required
                                                    v-model="passwordForm.password">
                                                <span class="help is-danger" v-if="passwordForm.errors.has('password')" v-text="passwordForm.errors.get('password')"></span>
                                              </div>

                                              <div class="input" v-show="passwordForm.status === 'verify'">
                                                <h5 v-if="lang === 'ar'">اكد كلمة المرور</h5>
                                                <h5 v-else>Verify Password:</h5>
                                                <input
                                                    :class="{'is-danger-input': passwordForm.errors.has('password2')}"
                                                    type="password"
                                                    id="password2" required
                                                    v-model="passwordForm.password_confirmation">
                                                <span class="help is-danger" v-if="passwordForm.errors.has('password2')" v-text="passwordForm.errors.get('password2')"></span>
                                              </div>

                                                <h5 v-if="lang === 'ar'">المستخدمين المسجلين ، يرجى <router-link to="/login">الضغط هنا</router-link> لتسجيل الدخول</h5>
                                                <h5 v-else>Registered users, please <span style="color: #1e88e5; cursor: pointer;" @click="view = 'login'">Click Here</span> to login to your account</h5>

                                                <div>
                                                    <p align="right">
                                                        <span style="color: #1e88e5; cursor: pointer;" v-on:click="forgotEmail">Forgot Email?</span>
                                                        <button  v-on:click="requestPassword" v-show="lang === 'ar' && passwordForm.status === 'code'" type="button" class="buttonx"><icon name="envelope" scale="1.5"></icon> إرسال رمز التحقق  </button>
                                                        <button  v-on:click="requestPassword" v-show="lang === 'en' && passwordForm.status === 'code'"  type="button" class="buttonx"><icon name="envelope" scale="1.5"></icon> Send Verification Code</button>&nbsp;
                                                      <button  v-on:click="requestPassword2" v-show="lang === 'ar' && passwordForm.status === 'verify'" type="button" class="buttonx"><icon name="lock" scale="1.5"></icon> تغيير كلمة المرور  </button>
                                                      <button  v-on:click="requestPassword2" v-show="lang === 'en' && passwordForm.status === 'verify'"  type="button" class="buttonx"><icon name="lock" scale="1.5"></icon> Change Password</button>&nbsp;

                                                    </p>
                                                </div>
                                            </form>
                                        </div>

                                    </div>
                                </div>
                            </div>



                        </div>
                        <div class="col-md-12"><br/><br/>&nbsp;
                        </div>

                    </div>




                </div>
            </div>
        </section>
    </div>
</template>

<script>
  import {Form, Errors} from '@/components/validations/forms';
  import router from './../../router'

  import {mixin} from '@/mixins/mixins';
  export default {
    mixins: [mixin],
    data () {
      return {
          view: 'login',
        form: new Form({
          name: null,
          company: null,
          email: '',
          password: '',
          password_confirmation: '',
          isDisabled: false,
        }),

          emailForm: new Form({
              mobile: null,
          }),

          passwordForm: new Form({
              mobile: null,
              token: '',
              status: 'code',
              password: null,
              password_confirmation: '',
              isDisabled: false,
          }),

      }
    },
    props: ['redirect'],
    methods: {
      onSubmit () {
        this.form.isDisabled = true;
        this.$store.dispatch('auth/login', this.form)
          .then(response => {
            this.form.onSuccess(response);
            if(this.redirect){router.replace(this.redirect)} else{router.replace('/dashboard')};
            this.form.isDisabled = false;
          })
          .catch(error => {
//            alert(JSON.stringify(error))
            this.form.onFail(error);
            this.form.isDisabled = false;
            if(this.lang === 'ar'){this.$snotify.error('تفاصيل غير صالحة. الرجاء إدخال المعلومات الصحيحة.');}
            else{this.$snotify.error(this.form.errors.error.message, this.form.errors.error.title);}

          })
      },

        requestEmail() {
            this.$store.dispatch('auth/requestEmail', this.emailForm)
                .then(response => {
                    this.$snotify.success(response.message);
                    this.emailForm.onSuccess(response);
                    this.view = 'login';
                })
                .catch(error => {
                    this.emailForm.onFail(error);
                    this.$snotify.error(this.emailForm.errors.error.message, this.emailForm.errors.error.title);
                    // if(this.lang === 'ar'){this.$snotify.error('تفاصيل غير صالحة. الرجاء إدخال المعلومات الصحيحة.');}
                    // else{this.$snotify.error(this.emailForm.errors.error.message, this.emailForm.errors.error.title);}
                })
        },


        requestPassword() {
          let oldMobile = this.passwordForm.mobile;
            this.$store.dispatch('auth/requestPassword', this.passwordForm)
                .then(response => {
                    this.$snotify.success(response.message);
                    this.passwordForm.onSuccess(response);
                    this.passwordForm.status = 'verify';
                    this.passwordForm.mobile = oldMobile;

                })
                .catch(error => {
                    this.passwordForm.onFail(error);
                    this.$snotify.error(this.passwordForm.errors.error.message, this.passwordForm.errors.error.title);
                    // if(this.lang === 'ar'){this.$snotify.error('تفاصيل غير صالحة. الرجاء إدخال المعلومات الصحيحة.');}
                    // else{this.$snotify.error(this.emailForm.errors.error.message, this.emailForm.errors.error.title);}
                })
        },

        requestPassword2() {
            this.$store.dispatch('auth/requestPassword', this.passwordForm)
                .then(response => {
                    this.$snotify.success(response.message);
                    this.passwordForm.onSuccess(response);
                    this.view = 'login';
                })
                .catch(error => {
                    this.passwordForm.onFail(error);
                    this.$snotify.error(this.passwordForm.errors.error.message, this.passwordForm.errors.error.title);
                    // if(this.lang === 'ar'){this.$snotify.error('تفاصيل غير صالحة. الرجاء إدخال المعلومات الصحيحة.');}
                    // else{this.$snotify.error(this.emailForm.errors.error.message, this.emailForm.errors.error.title);}
                })
        },

        forgotEmail(){
          this.view = 'email';
        },

        forgotPassword(){
            this.view = 'password';
            this.passwordForm.status = 'code';
        }
    }
  }
</script>

<style scoped>
    .signin-form {
        width: 400px;
        margin: 30px auto;
        border: 1px solid #eee;
        padding: 20px;
        box-shadow: 0 2px 3px #ccc;
        background-color: white;
        padding-bottom: 50px;
    }

    .input {
        margin: 10px auto;
    }

    .input label {
        display: block;
        color: #4e4e4e;
        margin-bottom: 6px;
    }

    .input input {
        font: inherit;
        width: 100%;
        padding: 6px 12px;
        box-sizing: border-box;
        border: 1px solid #ccc;
    }

    .input input:focus {
        outline: none;
        border: 1px solid #521751;
        background-color: #eee;
    }

    .submit{
        float: right;
    }

    .submit button[disabled],
    .submit button[disabled]:hover,
    .submit button[disabled]:active {
        border: 1px solid #ccc;
        background-color: transparent;
        color: #ccc;
        cursor: not-allowed;
    }

    .signup-form {
        max-width: 700px;
        text-align: center;
        margin: 20px auto;
    }
    .signup-form input,
    .signup-form textarea {
        border: solid 1px grey;
        outline: 0;
        padding: 2em;
        -moz-border-radius: 8px;
        -webkit-border-radius: 8px;
        border-radius: 8px;
        display: block;
        width: 100%;
        margin-top: 1em;
        font-family: "Merriweather", sans-serif;
        -moz-box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
        resize: none;
    }
    .signup-form input:focus,
    .signup-form textarea:focus {
        -moz-box-shadow: 0 0px 2px #e74c3c !important;
        -webkit-box-shadow: 0 0px 2px #e74c3c !important;
        box-shadow: 0 0px 2px #e74c3c !important;
    }
    .signup-form #input-submit {
        color: white;
        background: #e74c3c;
        cursor: pointer;
    }
    .signup-form #input-submit:hover {
        -moz-box-shadow: 0 3px 3px 3px rgba(170, 170, 170, 0.6);
        -webkit-box-shadow: 0 3px 3px 3px rgba(170, 170, 170, 0.6);
        box-shadow: 0 3px 3px 3px rgba(170, 170, 170, 0.6);
    }
    .signup-form textarea {
        height: 252px;
    }
    .shadows{
        -moz-box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
        box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
    }
    .signup-form button{
        border: solid 1px grey;
        outline: 0;
        padding: 1em;
        -moz-border-radius: 8px;
        -webkit-border-radius: 8px;
        border-radius: 8px;
        display: block;
        width: 100%;
        margin-top: 1em;
        font-family: "Merriweather", sans-serif;
        -moz-box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
        resize: none;
        color: white;
        background: #009d0b;
        cursor: pointer;
        font-size: 16px;
    }
    .buttonx{
        color: white !important;
        background: #009d0b !important;
    }
    .buttony{
        color: white !important;
        background: #e74c3c !important;
    }

    .activeTab{
        background-color: #D04A58; border: solid 1px darkgrey; height: 70px; text-align: center; padding-top: 20px; color: white; margin-bottom: 10px;
    }
    .inactiveTab{
        background-color: #afafaf; color: white; border: solid 1px darkgrey; height: 70px; text-align: center; padding-top: 20px; color: white; margin-bottom: 10px;
    }

</style>


// WEBPACK FOOTER //
// src/components/login/login.vue